import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Prodotto} from "../../Progetti/Models/Prodotto";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {IDropdownSettings} from "ng-multiselect-dropdown";
import {ProdottiStoreService} from "../../Progetti/_services/prodotti-store.service";
import {ToastrService} from "ngx-toastr";
import {ApiRestService} from "../api-rest.service";
import {ProdottoListino} from "../_Models";

@Component({
  selector: 'app-listino-prodotti-edit',
  templateUrl: './listino-prodotti-edit.component.html'
})
export class ListinoProdottiEditComponent implements OnInit {
  dropdownSettings:IDropdownSettings = {
    singleSelection: false,
    closeDropDownOnSelection: true,
    idField: 'id',
    textField: 'prodotto',
    searchPlaceholderText: "inserire almeno 3 caratteri",
    allowSearchFilter: true,
    allowRemoteDataSearch: true,
  };
  Prodotti: Prodotto[]  = [];
  ProdottiSelezionati: Prodotto[] = [];
  @Output() Saved = new EventEmitter();
  @Input() isModal: boolean = true;
  @Input() prodotto: ProdottoListino;
  constructor(
    private ngbActiveModal: NgbActiveModal,
    private progettiStore: ProdottiStoreService,
    private toastService: ToastrService,
    private apirestservice: ApiRestService,
  ) { }

  ngOnInit(): void {
    this.Refresh()
    this.progettiStore.$prodotti.subscribe(data=>{
      this.Prodotti = data?.data ?? [];
    })
  }
  Refresh() {
    this.filtroProdotti('')
    this.ProdottiSelezionati = this.prodotto?.prodottoObject ? [this.prodotto?.prodottoObject] : [];
  }

  getids(value: any[]): number[]{
    const Output: number[] = [];
    value?.forEach(item=> Output.push(item.id));
    return Output;
  }
  getid(value: any[]): any{
    return value?.length > 0 && value[0]? value[0].id : undefined;
  }
  private getDaForm() {
    var out: ProdottoListino = this.prodotto;
    out.id_prodotto = this.getid(this.ProdottiSelezionati);
    return out;
  }
  saveClick() {
    if (this.prodotto.id)
      this.apirestservice.ProdottiListinoProdottiUpdate(this.getDaForm()).subscribe(() => this.Refresh())
    else
      this.apirestservice.ProdottiListinoProdottiAdd(this.getDaForm()).subscribe(() => this.Refresh())
  }
  close() {
    this.ngbActiveModal.dismiss();
  }
  filtroProdotti(prodotto: string) {
   this.progettiStore.getProdotti(new Prodotto(0, 10, undefined, 'asc', prodotto));
  }
}
